<template>
  <div
    class="flex flex-col justify-between gap-5 bg-blue-100 pb-6 pl-5 pr-8 pt-4 sm:flex-row"
  >
    <div class="flex gap-5">
      <LazyIconFielmannInfoCircle class="size-6 shrink-0 text-button-outline" />
      <div class="flex flex-col">
        <Headline tag="h4" look="h5">{{
          $t('rxConfigurator.service.title')
        }}</Headline>
        <span
          v-dompurify-html="$t('rxConfigurator.service.description')"
          class="text-pretty"
        />
      </div>
    </div>
    <div class="my-auto">
      <FimButton
        type="secondary"
        class="w-full"
        :to="customerServicePhoneUrl"
        is-small
        >{{ $t('rxConfigurator.service.cta') }}</FimButton
      >
    </div>
  </div>
</template>

<script setup lang="ts">
const $i18n = useI18n()
const customerServicePhoneUrl = `tel:${$i18n.t('rxConfigurator.service.phone_number')}`
</script>
